module.exports = __webpack_public_path__ + "static/media/amphibians.6f98c38d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Helpers/Storage/Images/amphibians.svg
// module id = 495
// module chunks = 0